import Icon from '../../Icon/Icon';
import EditorButton from '../EditorButton/EditorButton';
import type { ReactNode } from 'react';
import './EditorLockable.css';

type V = unknown;

interface EditorLockableProps {
  locks: readonly V[];
  currentLock: V;
  onUpdateLock: (val: V) => void;
  editors: ReactNode[];
}

export default function EditorLockable({
  locks,
  currentLock,
  onUpdateLock,
  editors
}: EditorLockableProps) {
  return (
    <div className="EditorLockable">
      <div className="EditorLockable-inner">
        {editors.map((editor, i) => (
          <div key={i} className="EditorLockable-lockable">
            <div className="EditorLockable-lockableEditor">{editor}</div>
            <div className="EditorLockable-lock">
              <EditorButton
                disabled={i === locks.findIndex((val) => val === currentLock)}
                className="EditorLockable-lockableButton"
                onClick={() => onUpdateLock(locks[i])}
              >
                {i === locks.findIndex((val) => val === currentLock) ? (
                  <Icon kind="locked" size={15} />
                ) : (
                  <Icon kind="unlocked" size={15} />
                )}
              </EditorButton>
              <div className="EditorLockable-line" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
